<template>
  <div class="container mx-auto mb-4 mt-4">
    <div>
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100">
        <input type="hidden" id="id" v-model="form.id" />
        <input type="hidden" id="user_id" v-model="form.user_id" />

        <div class="pt-4 pb-2">
          <div>
            <h3 class="px-4 font-semibold text-brand-blue-400">
              Company Name<span class="text-brand-sienna-400 text ml-1">required</span>
            </h3>
            <p class="px-4 mb-2">
              Add a company name to your review so that AXA staff can find it easily in
              the future.
            </p>
            <div class="px-4">
              <input
                v-model="form.company"
                class="w-full p-2 mb-4 bg-white-100 border-2"
                maxlength="50"
                :disabled="isDisabled()"
                autocomplete="off"
              />
              <div v-if="form.errors.company" class="text-red-500 font-bold text-sm">
                {{ form.errors.company }}
              </div>
            </div>
          </div>

		  <div>
            <h3 class="px-4 font-semibold text-brand-blue-400">
              Phone Number<span class="text-brand-sienna-400 text ml-1">required</span>
            </h3>
            <p class="px-4 mb-2">
              Add a phone number to your review so that AXA staff can contact you easily in
              the future.
            </p>
            <div class="px-4">
              <input
                v-model="form.phone_number"
                class="w-full p-2 mb-4 bg-white-100 border-2"
                maxlength="50"
                :disabled="isDisabled()"
                autocomplete="off"
              />
              <div v-if="form.errors.phone_number" class="text-red-500 font-bold text-sm mb-8">
                {{ form.errors.phone_number }}
              </div>
            </div>
          </div>

          <div>
            <h3 class="px-4 font-semibold text-brand-blue-400">
              Review Title<span class="text-brand-sienna-400 text ml-1">required</span>
            </h3>
            <p class="px-4 mb-2">
              Add a title to your review so that you can find it easily in the future.
            </p>
            <div class="px-4">
              <input
                v-model="form.title"
                class="w-full p-2 mb-4 bg-white-100 border-2"
                maxlength="50"
                :disabled="isDisabled()"
                autocomplete="off"
              />
              <div v-if="form.errors.title" class="text-red-500 font-bold text-sm">
                {{ form.errors.title }}
              </div>
            </div>
          </div>

          <div>
            <h3 class="px-4 mt-4 font-semibold text-brand-blue-400">
              Review Description
            </h3>
            <p class="px-4 mb-2">
              You can add a short description to a review as notes and reminders for the
              future..
            </p>
            <div class="px-4">
              <textarea
                v-model="form.body"
                class="w-full p-2 mb-2 bg-white-100 border-2"
                maxlength="1024"
                :disabled="isDisabled()"
                autocomplete="off"
              >
					{{ form.body }}
					</textarea
              >
              <div v-if="form.errors.body" class="text-red-500 font-bold text-sm">
                {{ form.errors.body }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	<div v-if="review.status === 'submitted'" class="container mx-auto p-4 mb-4 rounded-md bg-brand-taupe-100">
		<h3 class="text-brand-blue-400 text-2xl font-semibold mb-6">
			Overall Score
		</h3>
		<div :class="overallScoreBorderColourClass" v-html="overallScoreMeaning"></div>
	</div>
    <div v-for="section in this.reviewTemplate.sections" :key="section.id" class="mb-10">
      <Section
        :section="section"
        :review="review"
        :form="form"
		:admin-view="adminView"
        @update="updateCanBeSubmitted"
      />
    </div>
  </div>
  <div class="flex px-4 gap-4 justify-between">
    <div class=""></div>
  </div>
</template>

<script>
import Section from "./Section";

export default {
  components: {
    Section,
  },
  computed: {
	overallScoreBorderColourClass() {
		let score = this.review.scores.find(s => s.section_id === null);

		return "border-l-8 p-3 " + ((score && score.class) ?? "");
	},
	overallScoreMeaning() {
		let score = this.review.scores.find(s => s.section_id === null);

		return (score && score.meaning) ?? "N/A";
	},
  },
  props: ["adminView", "reviewTemplate", "review", "form"],
  mounted() {
    this.updateCanBeSubmitted();
  },
  methods: {
    isDisabled() {
      if (this.review.status === "submitted" || this.adminView === true ) {
        return true;
      } else {
        return false;
      }
    },
    updateCanBeSubmitted() {
      let visibleQuestions = 0;
      let givenAnswers = 0;

      for (let i = 0; i < this.reviewTemplate.sections.length; i++) {
        let section = this.reviewTemplate.sections[i];
        for (let j = 0; j < section.questions.length; j++) {
          let question = section.questions[j];
          let element = document.getElementById("qindex-" + question.qindex);
          if (element && !element.classList.contains("hidden")) {
            visibleQuestions++;
          }
        }
      }

      for (let i = 0; i < this.form.newResponses.length; i++) {
        if (this.form.newResponses[i] !== undefined) {
          givenAnswers++;
        }
      }

      this.review.canBeSubmitted = visibleQuestions <= givenAnswers;
    },

  },
};
</script>
